<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        class="screenInput"
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        @change="screenParkChange"
        ><el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.audit_user_id"
        :disabled="screen.park_id == ''"
        placeholder="请选择审核人"
      >
        <el-option label="全部审核人" value=""></el-option>
        <el-option
          :key="index"
          v-for="(item, index) in userList"
          :label="item.username"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.title"
        placeholder="请输入标题"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.code"
        placeholder="请输入商品编号"
      ></el-input>

      <el-select
        class="screenInput"
        filterable
        v-model="screen.audit_status"
        placeholder="请选择审核状态"
      >
        <el-option label="全部审核状态" value=""></el-option>
        <el-option label="未审核" value="1"></el-option>
        <el-option label="审核通过" value="2"></el-option>
        <el-option label="已驳回" value="3"></el-option>
      </el-select>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.is_up"
        placeholder="请选择上下架"
      >
        <el-option label="全部上下架" value=""></el-option>
        <el-option label="上架" value="1"></el-option>
        <el-option label="下架" value="2"></el-option>
      </el-select>
      <el-button type="primary" @click="(screen.page = 1), fetchData()"
        >搜索</el-button
      >
      <el-button type="primary" plain @click="reset()">重置</el-button>
    </div>
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin: 10px 0"
      v-if="roles.includes('/mall/product_add')"
      >添加</el-button
    >
    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品标题" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label="商品编号" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.code }}</div>
        </template>
      </el-table-column>
      <el-table-column label="商品封面图" min-width="200">
        <template slot-scope="scope">
          <el-image
            style="width: 170px; height: 100px; margin: 0 5px 5px 0"
            :src="imageOss + scope.row.image"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.image.split(','))"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="原销售价格" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.origin_price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="实际销售价格" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="运费" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.freight_charge }}</span>
        </template>
      </el-table-column>
      <el-table-column label="库存" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.stock == '-1'">无限</span>
          <span v-else>{{ scope.row.stock }}</span>
        </template>
      </el-table-column>
      <el-table-column label="上下架状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_up == 1" type="success">上架</el-tag>
          <el-tag v-else-if="scope.row.is_up == 2" type="danger">下架</el-tag>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.audit_status == 1">未审核</el-tag>
          <el-tag v-else-if="scope.row.audit_status == 2" type="success"
            >审核通过</el-tag
          >
          <!-- <el-tag v-else-if="scope.row.audit_status == 3" type="danger"
            >已驳回</el-tag
          > -->
          <el-popover
            v-else-if="scope.row.audit_status == 3"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="scope.row.reason"
            >
            <el-tag slot="reference" type="danger">
              已驳回
              <i class="el-icon-question"></i>
            </el-tag>
          </el-popover>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="审核人" min-width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.audit_user">
            {{ scope.row.audit_user.username }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="审核时间" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.audit_time }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="驳回原因" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.reason }}</div>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="created_at"
        label="操作"
        fixed="right"
        min-width="280"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/mall/product_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/mall/product_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="examine(scope.row.id)"
            v-if="
              roles.includes('/mall/product_audit') &&
              scope.row.audit_status != 2&&scope.row.is_up == 1
            "
            >审批</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/mall/product_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="shopForm"
        :rules="rules"
        ref="shopForm"
        label-width="120px"
        class="demo-shopForm"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="shopForm.park_id"
            placeholder="请选择园区"
            :disabled="czType == 'see' || userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择商品类型" prop="mall_product_type_id">
          <el-select
            filterable
            v-model="shopForm.mall_product_type_id"
            placeholder="请选择商品类型"
            :disabled="czType == 'see' || shopForm.park_id == ''"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in shopType"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="title">
          <el-input
          :disabled="czType == 'see'"
            class="w4"
            v-model="shopForm.title"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品封面图" prop="image">
          <el-upload
            :limit="1"
            name="file[]"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            accept="image/*"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="imageList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :disabled="czType == 'see'"
            :class="imageList.length > 0 ? 'hide' : ''"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
        </el-form-item>
        <el-form-item label="商品图片" prop="banner">
          <el-upload
            :limit="6"
            name="file[]"
            :data="{ type: 'image' }"
            class="avatar-uploaders1"
            :action="ossUpload"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="bannerList"
            :on-remove="bannerRemovePic"
            :on-success="bannerAvatarSuccess"
            :disabled="czType == 'see'"
            accept=".jpg,.png,.jpeg"
            :class="bannerList.length > 5 ? 'hide' : ''"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="pic-tips">商品图片，最多6张</div>
        </el-form-item>
        <!-- <el-form-item label="商品描述" prop="des">
          <el-input
          :disabled="czType == 'see'"
            type="textarea"
            :rows="2"
            class="w4"
            v-model="shopForm.des"
            placeholder="请输入商品描述"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="售后电话" prop="phone">
          <el-input
          :disabled="czType == 'see'"
            class="w4 numInput"
            type="phone"
            v-model="shopForm.phone"
            placeholder="请输入售后电话"
            maxlength="11"
            ></el-input
          >
        </el-form-item>
        <el-form-item label="原销售价格" prop="origin_price">
          <el-input
          :disabled="czType == 'see'"
            class="w4 numInput"
            type="number"
            v-model="shopForm.origin_price"
            placeholder="请输入原销售价格"
            min="0"
            ><template slot="append">元</template></el-input
          >
        </el-form-item>
        <el-form-item label="实际销售价格" prop="price">
          <el-input
          :disabled="czType == 'see'"
            class="w4 numInput"
            type="number"
            v-model="shopForm.price"
            min="0"
            placeholder="请输入实际销售价格"
            ><template slot="append">元</template></el-input
          >
        </el-form-item>
        <el-form-item label="发货地" prop="origin">
          <el-input
          :disabled="czType == 'see'"
            class="w4"
            v-model="shopForm.origin"
            placeholder="请输入发货地"
          ></el-input>
        </el-form-item>
        <el-form-item label="运费" prop="freight_charge">
          <el-input
          :disabled="czType == 'see'"
            class="w4 numInput"
            type="number"
            min="0"
            v-model="shopForm.freight_charge"
            placeholder="请输入运费"
            ><template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="库存" prop="stock">
          <el-input
          :disabled="czType == 'see'"
            class="w4 numInput"
            type="number"
            min="-1"
            v-model="shopForm.stock"
            placeholder="请输入库存，-1表示无限"
          ></el-input>
        </el-form-item>
        <el-form-item label="上下架状态" prop="is_up">
          <el-radio-group v-model="shopForm.is_up" :disabled="czType == 'see'">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="序号" prop="sort">
          <el-input
          :disabled="czType == 'see'"
            class="w4 numInput"
            v-model="shopForm.sort"
            placeholder="请输入序号"
            type="number"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品详情" prop="details">
          <Editor
          :disabled="czType == 'see'"
            ref="myQuillEditor"
            style="width: 100%"
            v-model="shopForm.details"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('shopForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('shopForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="czType == 'add'"
            type="info"
            @click="drawer = false"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-dialog title="审批" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item
          label="审核"
          prop="audit_status"
          :rules="[
            { required: true, message: '请选择审核', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="form.audit_status">
            <el-radio :label="2">审核通过</el-radio>
            <el-radio :label="3">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item  :rules="[
            { required: true, message: '请输入驳回意见', trigger: 'change' },
          ]" prop="reason" label="驳回意见" v-if="form.audit_status == 3">
          <el-input type="textarea" v-model="form.reason"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="auditForm('form')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { openPark, adminUser } from "@/api/index";
import { mapGetters } from "vuex";
import {
  productAdd,
  productDel,
  productEdit,
  productInfo,
  productLists,
  productAudit,
  openTypeLists
} from "@/api/shop";
import { getToken } from "@/utils/auth";
import Editor from "@/components/Editor";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ossUpload: this.$store.state.ossUpload,
      listLoading: false,
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        title: "",
        code: "",
        is_up: "",
        audit_status: "",
        audit_user_id: "",
      },
      parkList: [],
      list: [],
      total: 0,
      userList: [],
      dialogVisible: false,
      form: {
        id: "",
        audit_status: "",
        reason: "",
      },
      rules: {
        audit_status: [{ required: true, message: "请选择审核", trigger: "change" }],
        reason: [
          { required: true, message: "请输入驳回意见", trigger: "blur" },
        ],
      },
      drawerTitle: "",
      czType: "",
      drawer: false,
      shopForm: {},
      imageList: [],
      bannerList: [],
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        title: [{ required: true, message: "请输入商品名称", trigger: 'blur'  }],
        image: [{ required: true, message: "请选择商品封面图" , trigger: 'change'}],
        banner: [{ required: true, message: "请选择商品图片" , trigger: 'change'}],
        des: [{ required: true, message: "请输入商品描述", trigger: 'blur'  }],
        price: [{ required: true, message: "请输入实际销售价格", trigger: 'blur'  }],
        stock: [{ required: true, message: "请输入库存，-1表示无限", trigger: 'blur'  }],
        is_up: [{ required: true, message: "请选择上下架状态", trigger: 'change' }],
        details: [{ required: true, message: "请输入商品详情" , trigger: 'blur' }],
        mall_product_type_id: [{ required: true, message: "请选择商品类型" , trigger: 'change' }],
      },
      shopType:[]
    };
  },
  created() {
    this.fetchData();
    this.getPark();
  },
  methods: {
     // 查看按钮
     handleInfo(e){
      this.drawerTitle = "查看";
      this.czType = "see";
      this.bannerList = []
      this.imageList = []
      this.getPark();
      this.parkChange(e.park_id)
      this.getInfo(e.id)
    },
    // 编辑按钮
    handleEdit(e){
      this.drawerTitle = "编辑";
      this.czType = "edit";
      this.bannerList = []
      this.imageList = []
      this.getPark();
      this.parkChange(e.park_id)
      this.getInfo(e.id)
    },
    getInfo(id){
      var that = this
      productInfo({id:id}).then(res=>{
        console.log(res)
        this.shopForm = {
        id: res.data.info.id,
        title: res.data.info.title,
        image: res.data.info.image,
        banner: res.data.info.banner.toString(),
        park_id: res.data.info.park_id,
        is_up: res.data.info.is_up,
        price: res.data.info.price,
        stock: res.data.info.stock,
        des: res.data.info.des,
        details: res.data.info.details,
        freight_charge: res.data.info.freight_charge,
        origin_price:res.data.info.origin_price,
        origin:res.data.info.origin,
        sort: res.data.info.sort,
        mall_product_type_id:res.data.info.mall_product_type_id,
        phone:res.data.info.phone
      };
      if(res.data.info.image){
        let list = res.data.info.image.split(",");
        this.imageList = list.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      }
      if(res.data.info.banner.length >0){
        let list = res.data.info.banner
        this.bannerList = list.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      }
      
      that.drawer = true;
      })
    },
    // 编辑
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.shopForm);
          productEdit(that.shopForm).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.drawer = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    // 添加
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.shopForm);
          productAdd(that.shopForm).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.drawer = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    // 园区选择
    parkChange(e){
      console.log(e)
      this.getType(e)
    },
    // 获取类型
    getType(id){
      openTypeLists({park_id:id}).then(res=>{
        console.log(res)
        this.shopType = res.data.lists.data
      })
    },
    // 商品图上传
    bannerAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        this.bannerList = fileList;
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.shopForm.banner = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.bannerList = list;
      }
    },
    // 商品图删除
    bannerRemovePic(file, fileList) {
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      console.log(list);
      this.shopForm.banner = list.join(",");
    },
    // 封面图上传
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        this.imageList = fileList;
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });

        this.shopForm.image = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.imageList = list;
      }
    },
    // 封面图删除
    handleRemovePic(file, fileList) {
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      console.log(list);
      this.imageList = []
      this.shopForm.image = list.join(",");
    },
    // 添加商品
    addMenu() {
      this.drawerTitle = "添加";
      this.czType = "add";
      this.shopForm = {
        title: "",
        image: "",
        banner: "",
        park_id: "",
        is_up: 2,
        price: "",
        stock: "",
        des: "",
        details: "",
        freight_charge: "",
        origin_price: "",
        origin: "",
        sort: "",
        mall_product_type_id:'',
        phone:''
      };
      this.imageList = [];
      this.bannerList = [];
      if (this.userInfo.park_id !== 0) {
        this.shopForm.park_id = this.userInfo.park_id;
        this.getType(this.userInfo.park_id)
      }
      this.$nextTick(() => {
        this.$refs.shopForm.clearValidate();
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          productDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.shopForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    auditForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          productAudit(that.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.dialogVisible = false;
              that.fetchData();
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 审核
    examine(id) {
      this.form = {
        id: id,
        audit_status: 2,
        reason: "",
      };
      this.dialogVisible = true;
    },
    screenParkChange() {
      this.getUserList();
    },
    // 获取后台审核人
    getUserList() {
      adminUser({ park_id: this.screen.park_id }).then((res) => {
        this.userList = res.data.lists.data;
      });
    },
    // 退款
    refund(id) {
      var that = this;
      this.$confirm("确认退款？")
        .then(() => {
          productAudit({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 分页
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 分页 end
    // 重置
    reset() {
      this.screen = {
        is_page: 1,
        page: 1,
        page_size: 15,
        park_id: "",
        title: "",
        code: "",
        is_up: "",
        audit_status: "",
        audit_user_id: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取数据
    fetchData() {
      this.listLoading = true;
      productLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .screenInput {
    width: 200px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.w4 {
  width: 40%;
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
